import { createContext } from 'react'

const agencyContext = createContext()

export default agencyContext
